module.exports = __webpack_public_path__ + "08_face.4ffafac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/08_face.png
// module id = XGlE
// module chunks = 0